<template>
    <auth-main>
      <perform-password-reset v-bind="$data" :token="token" v-loading="loading"></perform-password-reset>
    </auth-main>
</template>

<script>
  import AuthMain from '@/components/Authentication/AuthMain'
  import PerformPasswordReset from '@/components/Authentication/Forms/PerformPasswordReset'
  import ApiClient from '@/components/api-client'

  export default {
    name: 'reset-password',
    components: {
      AuthMain,
      PerformPasswordReset
    },
    data () {
      return {
        loading: true,
        canSet: false
      }
    },
    computed: {
      token () {
        return this.$route.query.et
      }
    },
    mounted () {
      ApiClient.checkPasswordResetToken(this.token)
        .then(() => {
          this.canSet = true
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
</script>

<style scoped>

</style>
